import * as React from 'react';

import classes from './typography.module.scss';

interface Props {
  as?: React.ElementType;
  [key: string]: any;
}

interface TextProps extends Props {
  variant?: 'title' | 'subtitle' | 'text';
}

export const Text = ({
  as: Component = 'p',
  variant = 'text',
  ...props
}: TextProps) => <Component className={classes[variant]} {...props} />;

export const Title = (props: Props) => <Text {...props} variant={'title'} />;
